export const convertToRelativePath = (url) => {
  if (!url) {
    return ''
  }

  return url
    .replaceAll('https://www.safesitefacilities.co.uk', '')
    .replaceAll('https://www.safesitesecuritysolutions.co.uk', '');
};
